import { REDUCE_POLICY_ELEMENT } from '../../constants/actions/policy';

export function reducePolicyElement(payload) {
    return {
        type: REDUCE_POLICY_ELEMENT,
        payload,
    };
}
